import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaFileExport, FaEraser } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, categoriasDeProgramas, getCurrentUser } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import Paginacao from '../../common/pagination';

class ProgramasV2 extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaPrograma = this.buscaPrograma.bind(this);
        this.limpaFiltro = this.limpaFiltro.bind(this);

        this.state = {
            listProgramas: [],
            error: "",
            busca: "",
            filtro_cliente_id: '',
            filtro_cliente_nome: '',
            page_numb: 1,
            loading: true,
        };
    }

    componentDidMount(){
        this.consultaProgramas(this.state.busca, this.state.limpa, this.state.page_numb)
    }

    consultaProgramas(busca, page_numb=1){
        let url=`/programas/?nome=${busca}&page=${page_numb}`
        if(this.state.filtro_cliente_id){
            url += `&cliente_id=${this.state.filtro_cliente_id}`
        }
        api.get(url)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listProgramas: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar programas, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }
    
    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'cliente_id') {
            this.setState(prevState => ({
                filtro_cliente_id: event.value, 
                filtro_cliente_nome: event.label,
                programa_select_key: prevState.programa_select_key + 1 
            }));
        }
    };
    renderRows = () => {
        if('results' in this.state.listProgramas && this.state.listProgramas.results.length > 0){
            return this.state.listProgramas.results.map((item) =>
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.nome}</td>
                <td>{item.dados_cliente.nome_fantasia}</td>
                <td>{categoriasDeProgramas[item.categoria]}</td>
                <td>{item.uuid}</td>
                <td>
                    {hasPerm('change_programas') && (
                    <Button variant="light" href={"/programas-v2/edit/"+item.id} size="sm">
                        <FaRegEdit /> Editar
                    </Button>  
                    )}  
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={6}>Nenhum programa cadastrado</td>
            </tr>
        );
    };

    onChangeBusca(e) {
        this.setState({
            busca: e.target.value
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaProgramas(this.state.busca, num_page)
    };

    buscaPrograma(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaProgramas(this.state.busca)
    };

    limpaFiltro = () => {
        this.setState({
            busca: '',
            filtro_cliente_id: null
        }, () => {
            this.consultaProgramas(this.state.busca, 1);
        })  
    }
    

    carregarClientes = async (inputValue) => {
        if(!this.state.focusCliente) {
            return [];
        }
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})`
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    render() {
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                fontSize: '13px',
            }),
            singleValue: (provided, state) => ({
                ...provided,
                fontSize: '13px',
            }),
        };
          
        let dados_usuario = getCurrentUser();
        if (!hasPerm('view_programas') || dados_usuario['tipo_usuario'] != '') {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Programas</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        {hasPerm('add_programas') && (
                        <Button variant="secondary" href="/programas-v2/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Programa
                        </Button>
                        )}
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="light" size="sm">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaPrograma}>
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="busca"
                                                                value={this.state.busca}
                                                                onChange={this.onChangeBusca}
                                                                placeholder="Nome do programa"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={12} xs={12}> 
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Cliente</Form.Label>
                                                            <AsyncSelect
                                                                key={this.state.focusCliente}
                                                                loadOptions={(inputValue) => {
                                                                    return new Promise((resolve) => {
                                                                        clearTimeout(this.clienteSearchTimeout);
                                                                        this.clienteSearchTimeout = setTimeout(() => {
                                                                            resolve(this.carregarClientes(inputValue));
                                                                        }, 700);
                                                                    });
                                                                }}
                                                                onFocus={() => {
                                                                    this.setState({
                                                                        focusCliente: true
                                                                    });
                                                                }}
                                                                autoFocus={this.state.focusCliente}
                                                                openMenuOnFocus={this.state.focusCliente}
                                                                defaultOptions
                                                                name="cliente_id"
                                                                placeholder="Nome do Cliente"
                                                                noOptionsMessage={() => "Nenhum cliente encontrado"}
                                                                onChange={e => this.handleChangeFiltros(e, 'cliente_id')}
                                                                value={this.state.filtro_cliente_id ? { value: this.state.filtro_cliente_id, label: this.state.filtro_cliente_nome } : null}
                                                                styles={{
                                                                    option: (provided) => ({
                                                                      ...provided,
                                                                      fontSize: '12px', // Ajusta o tamanho da fonte dos resultados
                                                                    }),
                                                                    }}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Button type="submit" variant="light" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>

                                                <Button className="ms-0" type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                                    <FaEraser /> Limpar Filtro
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                                
                                <Button variant="light" className="ms-2" size="sm">
                                    <FaFileExport /> Exportar
                                </Button>
                            </Col>
                        </Row>    

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>Cliente</th>
                                    <th>Categoria</th>
                                    <th>UUID</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={5}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={6}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listProgramas && this.state.listProgramas.results.length > 0 && 
                            <Paginacao dados={this.state.listProgramas} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(ProgramasV2);